import { Box, HStack, Header, Text } from '@rbilabs/universal-components';

export const NutritionInformationWrapper = Box.withConfig({
  paddingX: { base: 4, md: 0 },
  _android: {
    height: '100%',
  },
});

export const NutritionInformationTitle = Header.withConfig({
  variant: 'headerThree',
  lineHeight: 'lg',
});

export const NutritionInformationContainer = Box.withConfig({
  marginY: {
    base: '$2',
    md: '$6',
  },
});

export const AllergensDisclaimerContainer = Text.withConfig({
  variant: 'copyTwo',
  marginBottom: '$4',
  fontSize: 'xs',
});

export const AllergenNames = Text.withConfig({
  variant: 'copyTwo',
  fontWeight: 'bold',
});

export const NutrientText = HStack.withConfig({
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 1,
  focusable: true,
});
